import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { FailedTransactionMessageFacadeInterface } from '../../models';
import { Sc4FailedTransactionMessageState } from './sc4-failed-transaction-message.state';
import {
  WaybillFailedTransactionMessageInitialState,
  WaybillFailedTransactionMessageLoad,
} from './sc4-failed-transaction-message.actions';

@Injectable({ providedIn: 'root' })
export class Sc4FailedTransactionMessageFacade implements FailedTransactionMessageFacadeInterface {
  failedTransactionMessage$: Observable<string> = this.store.select(
    Sc4FailedTransactionMessageState.getWaybillFailedTransactionMessage,
  );
  loaded$: Observable<boolean> = this.store.select(Sc4FailedTransactionMessageState.getLoaded);

  constructor(private store: Store) {}

  loadFailedTransactionMessage(rawMessageId: string): void {
    this.store.dispatch(new WaybillFailedTransactionMessageLoad(rawMessageId));
  }

  setInitialState(): void {
    this.store.dispatch(new WaybillFailedTransactionMessageInitialState());
  }
}
